/**
 * Copy a value to the users clipboard
 *
 * @param {string} value
 * @returns {void}
 */
export default function copyToClipboard(value) {
  const input = document.createElement("input");
  input.style = "position: absolute; top: 0; left: -999em";
  input.value = value;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  return;
}
